/**
 *
 *
 *
 *
 *
 */

const STACK_GAP_PX = 8;

type StackEntry = {
  host: HTMLElement;
  snackbarEl: HTMLElement;
};

/*                                                            */
const stack: StackEntry[] = [];

/**
 *
 *
 *
 *
 *
 *
 */
function repositionStack(): void {
  let offset = 0;
  for (let i = stack.length - 1; i >= 0; i--) {
    const { host, snackbarEl } = stack[i];
    host.style.setProperty("--snackbar-stack-offset", `${offset}px`);
    offset += snackbarEl.offsetHeight + STACK_GAP_PX;
  }
}

/**
 *
 *
 *
 *
 *
 *
 */
export function registerSnackbar(host: HTMLElement, snackbarEl: HTMLElement): () => void {
  const entry: StackEntry = { host, snackbarEl };
  stack.push(entry);

  const observer = new ResizeObserver(repositionStack);
  observer.observe(snackbarEl);

  repositionStack();

  return () => {
    observer.disconnect();
    const idx = stack.indexOf(entry);
    if (idx !== -1) stack.splice(idx, 1);
    repositionStack();
  };
}
